import { browser } from "$app/environment";

export const getCookie = <T>(name: string): T | null => {
  if (browser) {
    const value = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
    return value ? decodeURIComponent(value[2]) as T : null;
  }
  return null;
};

export const patchCookie = (name: string, value: Record<string, any>, days = 7): void => {
  const newValue = { ...(getCookie(name) || {}), ...value };
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(JSON.stringify(newValue))};expires=${expires};path=/`;
};

const getExpiration = (expiration: { day?: number; hour?: number; minute?: number }): string => {
  const { day = 0, hour = 0, minute = 0 } = expiration;
  const expirationTime = Date.now() + (day * 24 * 60 * 60 * 1000) + (hour * 60 * 60 * 1000) + (minute * 60 * 1000);
  return new Date(expirationTime).toUTCString();
}

export const setCookie = (name: string, value?: string, expiration?: { day?: number; hour?: number; minute?: number }): string => {
  if (value) {
    if (expiration) {
      document.cookie = `${name}=${encodeURIComponent(value)};expires=${getExpiration(expiration)};path=/`;
    } else {
      document.cookie = `${name}=${encodeURIComponent(value)};path=/`;
    }
  }
  return document.cookie;
};

export const deleteCookie = (name: string): void => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
};
